import React from 'react';
import { useBlog } from '../../hooks/useBlog';
import '../../styles/home.css';

// Capítulo BLOG — 3 posts REAIS via useBlog; sem posts, a seção ensina (não some)
const COVER_GLYPHS: Record<string, string> = {
  Trânsitos: '☿',
  'Mapa Astral': '◎',
  Sinastria: '♡',
};

export const HomeBlog: React.FC = () => {
  const { posts, loading } = useBlog();
  const top = posts.slice(0, 3);

  return (
    <section id="blog" className="blog">
      <h2 className="display">Do blog do céu</h2>
      <p style={{ color: 'var(--muted)', marginTop: 6 }}>Guia sem enrolação — astros, rituais e decisões do dia-a-dia.</p>

      {loading && <p className="text-stela-muted text-[14px]">Carregando o céu…</p>}

      {!loading && (
        <div className="blog-grid">
          {top.map((post) => (
            <a key={post.id} href={`/blog/${post.slug}`} className="post">
              <div className="cover">
                <span className="g">{COVER_GLYPHS[post.categoryName] ?? '✧'}</span>
              </div>
              <div className="body">
                <span className="cat">{post.categoryName ?? 'Céu'}</span>
                <h3>{post.title}</h3>
                <p className="excerpt">{post.excerpt}</p>
                <span className="more">Ler guia →</span>
              </div>
            </a>
          ))}
          {top.length === 0 && (
            <div className="previa" style={{ gridColumn: '1 / -1', textAlign: 'center' }}>
              <span className="glyph">✒</span>
              <h3>Diário celestial em preparação</h3>
              <p style={{ flex: 0, color: 'var(--muted)' }}>
                A Stela está escrevendo os primeiros guias — voltar já para o mapa grátis.
              </p>
            </div>
          )}
        </div>
      )}
    </section>
  );
};